// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//Packages
import Vue from 'vue'//in use
import VeeValidate from 'vee-validate';//in use
import {VueAuthenticate} from 'vue-authenticate'//in use
import Vue2Dnd from 'vue2-dnd'//in use
import $auth from 'vue-authenticate'//in use
import VueScrollTo from 'vue-scrollto'//in use
import VueAxios from 'vue-axios'//in use
import axios from 'axios'//in use
import VueClipboard from 'vue-clipboard2'//in use
import VueSweetalert2 from 'vue-sweetalert2';//in use
import VueProgressBar from 'vue-progressbar'//in use
import VueAnalytics from 'vue-analytics'//in use
import Draggable from 'vuedraggable'//in use
import VueIziToast from 'vue-izitoast';
import StarRating from 'vue-star-rating'//in use
import Multiselect from 'vue-multiselect'//in use
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'//in use
import contextMenu from 'vue-context-menu'
import VueIntro from 'vue-introjs';//in use
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'//in use
import 'izitoast/dist/css/iziToast.css';//in use
import 'intro.js/introjs.css';//in use


//Define lodash globaly
window._ = require('lodash');

//Define global Mixin
import Http from './mixins/globalMixins';
Vue.mixin(Http);


//Services
import App from './App'
import router from './router'
import {EventBus} from './services/EventBus.js'

//Import Components
import VueTour from './components/util/VueTour.vue'
import SchoolModal from './components/util/SchoolModal.vue'
import BulmaPagination from './components/util/BulmaPagination.vue'
import SearchSelect from './components/util/SearchSelect.vue'
import CategoryTag from './components/category/CategoryTag'
import CategoryList from './components/category/CategoryList'
import SentenceTag from './components/sentences/SentenceTag'
import BulmaInput from './components/util/BulmaInput.vue'
import LoadingButton from './components/util/LoadingButton.vue'
import LoadingSubmit from './components/util/LoadingSubmit.vue'
import Collapse from './components/util/Collapse.vue'
import Item from './components/util/Item.vue'
import MagicWords from './components/util/MagicWords.vue'
import CreateSentenceModal from './components/sentences/CreateSentenceModal.vue'

//Define global components
Vue.component('draggable', Draggable);
Vue.component('star-rating', StarRating);
Vue.component('clip-loader', ClipLoader);
Vue.component('context-menu', contextMenu);
Vue.component('multiselect', Multiselect)
//Self made
Vue.component('category-tag', CategoryTag);
Vue.component('category-list', CategoryList);
Vue.component('sentence-tag', SentenceTag);
Vue.component('school-modal', SchoolModal);
Vue.component('search-select', SearchSelect);
Vue.component('bulma-input', BulmaInput);
Vue.component('loading-button', LoadingButton);
Vue.component('loading-submit', LoadingSubmit);
Vue.component('collapse', Collapse);
Vue.component('collapse-item', Item);
Vue.component('vue-tour', VueTour);
Vue.component('bulma-pagination', BulmaPagination);
Vue.component('accordion', BulmaAccordion);
Vue.component('accordion-item', BulmaAccordionItem);
Vue.component('magic-words', MagicWords);
Vue.component('create-sentence-modal', CreateSentenceModal);

//axios.defaults.baseURL = 'http://127.0.0.1:8000/';
//axios.defaults.baseURL = 'http://blablacommentz.test/';
//axios.defaults.baseURL = 'http://blablaapi.dinkara.com/';
axios.defaults.baseURL = 'https://api.blablacommentz.com/';

axios.defaults.storageURL = axios.defaults.baseURL + 'storage/';

Vue.use(VueIntro);

Vue.use(VueIziToast,
    {
        timeout: 5000,
        theme: 'dark',
        position: 'topCenter',
        progressBarColor: '#d5e1df'
    });
Vue.use(VueAnalytics, {
    id: 'UA-111495631-1',
    checkDuplicatedScript: true
})

Vue.prototype.$me = {
    price: 0,
    user: {
        profile: {
            name: ''
        },
        news : [],
        unseenNews :[]
    },
    id: -1
};


Vue.use(axios);
Vue.use(VueAxios, axios);
Vue.use(VeeValidate);
Vue.use(Vue2Dnd);
Vue.use(VueClipboard);
Vue.use(VueSweetalert2);
Vue.use(VueProgressBar, {
    color: '#00d1b2',
    failedColor: '#ff3860',
    thickness: '2px',
    autoRevert: true,
    location: 'top',
    inverse: false
})

Vue.prototype.$referral = null;

var auth_options = {
  baseUrl: axios.defaults.baseURL + "/api", // Your API domain
  tokenName: 'token',
  responseDataKey: 'data',
  logoutUrl: "api/logout",
  loginUrl: "/login",
  registerUrl: "/register",
  providers: {
      facebook: {
          clientId: '516738055355291',
          redirectUri: 'https://app.blablacommentz.com/', // Your client app URL
          //clientId: '822600857751391',
          //redirectUri: 'http://localhost:8080/', // Your client app URL
      },
    google: {
      clientId: '55138306884-3vefu9mekhlncgci48c0f5i075jr11jq.apps.googleusercontent.com',
      redirectUri: 'https://app.blablacommentz.com/', // Your client app URL
    }
  },

  /**
   * Default response interceptor for Axios library
   * @contect {VueAuthenticate}
   */
  bindResponseInterceptor: function ($auth) {
    $auth.$http.interceptors.response.use((response) => {
      $auth.setToken(response.data)
      return response
    })
  },

    /**
     * Default request interceptor for Axios library
     * @context {VueAuthenticate}
     */
    bindRequestInterceptor: function ($auth) {
        const tokenHeader = $auth.options.tokenHeader;


        $auth.$http.interceptors.request.use((config) => {

            if(Vue.prototype.$referral){
                config.data.referral = Vue.prototype.$referral;
            }
          if ($auth.isAuthenticated()) {
            config.headers[tokenHeader] = [
              $auth.options.tokenType, $auth.getToken()
            ].join(' ')
          }
          return config
        })
    },

};

const auth = new VueAuthenticate(axios, auth_options);

window.axios = axios
window.auth = auth

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    app.$Progress.start();
    // Do something before request is sent
    return config;
}, function (error) {
    app.$Progress.fail();
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    app.$Progress.finish();
    return response;
}, function (error) {
    // Do something with response error
    app.$Progress.fail();
    return Promise.reject(error);
});

Vue.config.productionTip = false

Vue.use($auth, auth_options);

// You can also pass in the default options
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: -10,
     cancelable: true,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })

var app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});

window.app = app;

window.addEventListener('unhandledrejection', event => {
    // Can prevent error output on the console:
    event.preventDefault();

    var promise = event.promise;

    promise.catch((error) =>{
	    EventBus.$emit("serverError", {component: app, error: error});
    });
});



// WEBPACK FOOTER //
// ./src/main.js